// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uKyJ","name":"styles_name__168tp","phone":"styles_phone__e8V-1"};